import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import { FormattedMessage } from 'react-intl';
import { Navigate, useParams } from 'react-router-dom';
import { initialModelState } from '../../reducers/initialState';


const ModelConfiguration = ({ userProfileWidgets,
  modelCleanUpThunk
}) => {

  // Check if the user has access to any of the widgets
  let { ModelCategoryId, ModelId } = useParams();


  useEffect(() => {
    return () => {
      modelCleanUpThunk({
        ...initialModelState.modelManager
      });
    };
  }, []);


  return (
    <div>
      {IsWidgetAccessible(userProfileWidgets, 'MODELVARIANTLIST') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-variants-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELCOMPONENTPOSITIONLIST') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-component-position-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELSETPOINTS') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-setpoints-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'SEQUENCEVERSIONLIST') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/sequence-version`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELTHRESHOLDS') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-thresholds-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'PERIODICSUMMARYSETTINGS') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/periodic-summary-settings-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELSERVICEPLANS') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/service-plan-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODEL_TELEMETRY_LINKS') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-component-position-telemetry-links`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'MODELFIRMWAREVERSIONLIST') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/model-firmware-version-list`} />
      ) : IsWidgetAccessible(userProfileWidgets, 'COMPANIONCONFIGVERSIONLIST') ? (
        <Navigate to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model-configuration/${ModelId}/companion-config-version-list`} />
      ) : (
        ''
      )}
      <span>
        <FormattedMessage
          id="modelCategory.noAccess"
          defaultMessage="You do not have access to model category operations. Please contact your administrator."
        />
      </span>
    </div>
  )
};

ModelConfiguration.propTypes = {
  userProfileWidgets: PropTypes.object.isRequired
};

export default ModelConfiguration;
